import type { SelectOption } from '../components/inputs/selectShared';

/**
 * The titles offered beside a first name.
 *
 * **A MIRROR of `Salutations.All` on the server, and the server is the authority.** The
 * validator refuses a salutation that is not on its list, so drift between these two fails
 * LOUDLY on save rather than silently storing a title no other screen offers — which is the
 * only reason a second copy is affordable at all. Add a title here and on the server in the
 * same change.
 *
 * Not fetched from an endpoint: seven fixed strings do not earn a request on every form open,
 * and a catalog table was offered and declined (09 Oct 2026) because an organization does not
 * add to this list the way it adds eligibilities or family relations.
 */
export const SALUTATIONS: readonly string[] = ['Mr.', 'Ms.', 'Mrs.', 'Dr.', 'Engr.', 'Atty.', 'Hon.'];

/**
 * As picker options. `sort="none"` at the call site keeps this order, which is deliberate:
 * the four general titles first, then the professional ones. Alphabetising would open the list
 * on "Atty.".
 */
export const SALUTATION_OPTIONS: SelectOption[] = SALUTATIONS.map((value) => ({
  value,
  label: value,
}));

/**
 * The salutation segment's width — FIVE CHARACTERS (the longest title, `Engr.`/`Atty.`) plus the
 * seamless control's own `pl-2 pr-2`, in the INPUT's size (`text-sm`, so `ch` measures the same font
 * the value is drawn in). Product call, 13 Oct 2026; it was `w-24`. ONE definition for every name row —
 * eight forms each carried their own copy.
 */
export const SALUTATION_SEGMENT_WIDTH = 'w-[calc(5ch+1rem)] shrink-0 text-sm';

/**
 * What the EMPTY segment shows. The segment's own label, "Salutation", does not fit five
 * characters; "Title" does, and is the word the field's own help text already uses for it.
 */
export const SALUTATION_EMPTY_LABEL = 'Title';
